import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// RoomCard component to render individual rooms
const RoomCard = ({ imgSrc, roomName, price, features,book }) => {
  return (
    <div className="col-lg-4 col-md-6 col-sm-12 col-12 mb-24">
      <div className="rx-rooms-box-2">
        <div className="rx-rooms-img">
          <img src={imgSrc} alt={roomName} />
          <div className="inner-back-side">
            <div className="sub-title">
              <h5>{roomName}</h5>
              <span className="rx-price">{price} /-</span>
            </div>
            <div className="inner-info">
              <ul>
                {features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
            <div className="rx-button">
              <Link to={book} className="rx-btn-one" target="_blank"> Book Now</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main Rooms component
const GoldRoom = () => {
  const rooms = [
    {
      imgSrc: 'img/rooms/room1.jpg',
      roomName: '1 Sharing Room',
      price: '8,500',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
      book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 1 sharing room (8,500 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room2.jpg',
      roomName: '2 Sharing Room',
      price: '7000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
      book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 2 Sharing Room (7,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room3.jpg',
      roomName: '3 Sharing Room',
      price: '6000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
      book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 3 Sharing Room (6,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room4.jpg',
      roomName: '1 Sharing Room',
      price: '8,500',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
      book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 1 Sharing Room (8,500 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room5.jpg',
      roomName: '2 Sharing Room',
      price: '7000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
      book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 2 Sharing Room (7,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room6.jpg',
      roomName: '3 Sharing Room',
      price: '6000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
      book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 3 Sharing Room (6,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },

    {
      imgSrc: 'img/rooms/room7.jpg',
      roomName: '1 Sharing Room',
      price: '8,500',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
       book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 1 Sharing Room (8,500 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },

    {
      imgSrc: 'img/rooms/room8.jpg',
      roomName: '2 Sharing Room',
      price: '7000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
       book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 2 Sharing Room (7,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room9.jpg',
      roomName: '3 Sharing Room',
      price: '6000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
     book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 3 Sharing Room (6,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room10.jpg',
      roomName: '1 Sharing Room',
      price: '8,500',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
        book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 1 Sharing Room (8,500 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room11.jpg',
      roomName: '2 Sharing Room',
      price: '7000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
        book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 2 Sharing Room (7,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room12.jpg',
      roomName: '3 Sharing Room',
      price: '6000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
        book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 3 Sharing Room (6,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room13.jpg',
      roomName: '1 Sharing Room',
      price: '8500',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
      book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 1 Sharing Room (8,500 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room14.jpg',
      roomName: '3 Sharing Room',
      price: '7000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
        book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 3 Sharing Room (7,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    },
    {
      imgSrc: 'img/rooms/room15.jpg',
      roomName: '3 Sharing Room',
      price: '6000',
      features: ['Daily cleaning', 'Room Service', 'Housekeeping', 'Wi-Fi & Parking'],
        book: 'https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking 3 Sharing Room (6,000 /-) at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!'
    }
  ];

  return (

    <>

<Helmet>
 
 <script type="application/ld+json">
   {JSON.stringify({
     "@context": "https://schema.org",
     "@type": "Organization",
     "name": "Om Sai PG",
     "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
     "url": "https://www.omsaipg.in",
     "logo": "https://www.omsaipg.in/images/logo.jpg",
     "image":"https://www.omsaipg.in/ogimage.jpg",
     "contactPoint": [
       {
         "@type": "ContactPoint",
         "telephone": "+91 9763888448",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
       {
         "@type": "ContactPoint",
         "telephone": "+91 9922248255",
         "contactType": "Customer Service",
         "areaServed": "IN",
         "availableLanguage": "English",
       },
     ],
     "aggregateRating": {
       "@type": "AggregateRating",
       "bestRating": "5",
       "worstRating": "1",
       "ratingValue": "4.7",
       "ratingCount": "250",
     },
     "email": "omsaipg@gmail.com",
     "address": {
       "@type": "PostalAddress",
       "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
       "addressLocality": "Kharadi",
       "addressRegion": "Maharashtra",
       "postalCode": "411014",
       "addressCountry": "IN",
     },
     "sameAs": [
       "https://www.facebook.com/omsaipg",
       "https://www.instagram.com/omsaipg",
       "https://www.linkedin.com/company/omsaipg"
     ],
     "priceRange": "INR 8,500-6000",
     "paymentAccepted": "Cash, UPI, Credit Card",
     "telephone": "+91 9763888448",
     "email": "omsaipgpune@gmail.com",
     "keywords": [
       "PG in Pune",
       "PG in Kharadi",
       "PG with food in Pune",
       "PG for students in Kharadi",
       "PG for females in Pune",
       "PG for males in Pune",
       "Om Sai PG Kharadi",
       "Girls Hostels in Kharadi",
       "Boys Hostel in Kharadi",
       "Monthly Basis PG in Kharadi",
       "PG in Wagholi",
       "PG in Kharadi with food",
       "Hostels in Pune",
       "PG for Students in Kharadi Pune",
       "Paying Guest Hostel in Chandan Nagar"
     ],
     "openingHours": "Mo-Su 09:00-22:00"
   })}
 </script>

 {/* Title */}
 <title>
   Contact : +91 9763888448 / +91 9922248255 |Room | Om Sai PG | Girls Hostels in Kharadi | Boys Hostel in Kharadi | Monthly Basis PG in Kharadi| PG in Wagholi
 </title>

 {/* Meta Tags */}
 <meta
   name="description"
   content="Om Sai PG offers the best PG accommodations in Kharadi, Pune. We provide PG for students, males, females, with food and other essential amenities."
 />
 <meta
   name="keywords"
   content="Girls Hostels in Kharadi,Boys Hostel in Kharadi, Monthly Basis PG in Kharadi, PG in Wagholi"
 />
 <meta name="robots" content="index, follow" />

 {/* Open Graph Tags */}
 <meta
   property="og:title"
   content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
 />
 <meta
   property="og:description"
   content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
 />
 <meta property="og:image" content="https://www.omsaipg.in/ogimage.jpg" />
 <meta property="og:url" content="https://www.omsaipg.in" />
 <meta property="og:type" content="website" />
</Helmet>

       <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img2">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>Room</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>Room</h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <a href="index.html">Home</a>
                                            </li>
                                            <li>Room</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section className="section-room padding-t-50 padding-b-100">
      <div className="container">
        <div className="row mb-minus-24">
          <div className="col-12">
            <div className="rx-banner text-center rx-banner-effects">
              <p>
                <img src="img/banner/left-shape.svg" alt="banner-left-shape" className="svg-img left-side" />
                Luxury Suites
                <img src="img/banner/right-shape.svg" alt="banner-right-shape" className="svg-img right-side" />
              </p>
              <h4>Our Best <span>Rooms</span></h4>
            </div>
          </div>
          
          {rooms.map((room, index) => (
            <RoomCard 
              key={index}
              imgSrc={room.imgSrc}
              roomName={room.roomName}
              price={room.price}
              features={room.features}
              book = {room.book}
            />
          ))}
          
        </div>
      </div>
    </section>
    

   
    </>
  );
};

export default GoldRoom;
